"use client";

import { useCurrencyRates } from "@/hooks/currency/useCurrencyRates";

/**
 * Component that initializes currency rates on app load.
 *
 * This ensures rates are fetched regardless of which page the user lands on,
 * fixing the issue where local currency wasn't shown on the campaigns page
 * when visited directly (because CurrencySelector was only rendered on
 * the home page for mobile users).
 */
export const CurrencyRatesInitializer: React.FC = () => {
  // This hook fetches rates and updates the currency store
  useCurrencyRates();

  // This component doesn't render anything
  return null;
};
